import styled from 'styled-components';
import {
  red, blue, darkerGrey, teko, tekoMedium, openSansBold, fontSizes,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

export const Container = styled.div`
  padding: 180px 100px;
  text-align: center;
  ${teko} display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${mobile.max}px) {
    padding: 57px 30px;
    background-size: cover;
    background-position: center center;
  }
`;

export const Wrapper = styled.div`
  max-width: 1100px;
`;

export const IntroLine = styled.div`
  text-align: center;
  margin-bottom: 22px;

  .text {
    color: ${blue};
    ${tekoMedium}
    font-size: ${fontSizes.headline}px;
    letter-spacing: 6.32px;
    text-transform: uppercase;

    @media (max-width: ${mobile.max}px) {
      font-size: 36px;
    }
  }

  .accent {
    display: block;
    width: 20px;
    height: 3px;
    background: ${red};
  }
`;

export const Headline = styled.div`
  color: ${darkerGrey};
  font-size: 22px;
  ${openSansBold}
  letter-spacing: 3.98px;
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: 49px;
  

  * {
    display: none;
  }

  p {
    display: block;
    color: ${darkerGrey};
    font-size: 22px;
    ${openSansBold}
    letter-spacing: 3.98px;
    line-height: 1.5;
  }

  img {
    display: block;
  }

  @media (max-width: ${mobile.max}px) {
    font-size: 13px;
    letter-spacing: 2.3px;
    margin-bottom: 30px;
    p {
      font-size: 13px;
      letter-spacing: 2.3px;
      margin-bottom: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/cta-promo/styles/cta-promo.style.js